module.exports = __webpack_public_path__ + "static/media/aspen-background.d73ca7b4.png";